import { TeamOutlined } from '@ant-design/icons';

const icons = {
  TeamOutlined
};

const patients = {
  id: 'patients-group',
  title: 'Pacientes',
  type: 'group',
  children: [
    {
      id: 'patients',
      title: 'Cadastros',
      type: 'item',
      url: '/cadastros/pacientes',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    }
  ]
};

export default patients;
